module.exports = __webpack_public_path__ + "media/feature/trust-fa285453.jpg";